import apiSlice from "./ApiSlice";

const dashboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Video Lecture Orders
    getDashboardOrder: builder.query({
      providesTags: ["dashboard"],
      query: (body) => ({
        url: `/dashboard/orders-summary`,
        method: "POST",
        body,
      }),
    }),

    // RazorPay Orders
    getRazorpayOrdersSummary: builder.query({
      providesTags: ["dashboard"],
      query: (body) => ({
        url: `/dashboard/razorpay-orders-summary`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetDashboardOrderQuery,
  useGetRazorpayOrdersSummaryQuery,
} = dashboardApi;
